<template>
  <div>
    <Breadcrumb origin-name="Communities" origin-path="/communities" :current-name="community.name" />
    <h3>Community Manager verwalten</h3>
    <List :columns="columns" :values="communityManager" emptyText="Bisher keine Community Manager vorhanden">
      <template #column_name="{data}">{{ data.firstName }} {{ data.lastName }}</template>
      <template #column_action="{data}">
        <div class="d-flex justify-content-center">
          <img @click="communityManagerToDelete = data" src="../../assets/icons/remove.svg" />
        </div>
      </template>
    </List>
    <button @click="$router.push('community-manager/add')" class="btn btn-primary">Community Manager hinzufügen</button>
    <Dialog :visible="communityManagerToDelete"
            title="Community Manager entfernen?"
            ok-button-text="Ja, entfernen!"
            @cancel="communityManagerToDelete = undefined"
            @ok="removeCommunityManager"
            :message="`Wollen Sie ${communityManagerToDelete ? communityManagerToDelete.firstName : ''} ${communityManagerToDelete ? communityManagerToDelete.lastName : ''} wirklich entfernen?`">
    </Dialog>
  </div>
</template>

<script>
import Breadcrumb from "@/components/partial/Breadcrumb.vue";
import {communicator} from "@/util/communicator";
import {broadcast} from "@/util/eventHandler";
import List from "@/components/partial/List.vue";
import Dialog from "@/components/partial/Dialog.vue";

export default {
  components: {Dialog, List, Breadcrumb},
  name: "CommunityManager",
  data() {
    return {
      communityManagerToDelete: undefined,
      communityManager: [],
      community: [],
      columns: [
        { name: "Name", key: "name" },
        { name: "E-Mail Adresse", key: "email" },
        { name: "Aktion", key: "action", styles: { width: "75px" } },
      ]
    };
  },
  created() {
    if(this.$route.params.id) {
      this.loadCommunityManager(this.$route.params.id);
      this.loadCommunity(this.$route.params.id);
    }
  },
  methods: {
    async loadCommunityManager(id) {
      try {
        const response = await communicator.get("/communities/" + id + "/community-manager");
        this.communityManager = response.data.items;
      } catch (e) {
        broadcast("error", e.response.data);
      }
    },
    async loadCommunity(id) {
      this.community = this.$store.state.communities.find(e => String(e.id) === id);
    },
    async removeCommunityManager() {
      if(!this.communityManagerToDelete) return;
      try {
        await communicator.delete("/communities/" + this.$route.params.id + "/community-manager/" + this.communityManagerToDelete.id);
        this.communityManagerToDelete = undefined;
        this.loadCommunityManager(this.$route.params.id);
      } catch (e) {
        broadcast("error", e.response.data);
      }
    }
  }
};
</script>

<style lang="scss">
.d-flex img:hover {
  cursor: pointer;
}
</style>
